import React from 'react';
import { Link } from 'react-router-dom';
export const AllHikingTrips = () => {
  const destinations = [{
    id: 1,
    country: 'Greece',
    image: 'https://images.unsplash.com/photo-1533105079780-92b9be482077?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    description: 'Explore ancient paths through olive groves and coastal trails with breathtaking Mediterranean views.',
    trips: 8
  }, {
    id: 2,
    country: 'Cyprus',
    image: 'https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1169&q=80',
    description: 'Discover the diverse landscapes of Cyprus, from mountain trails to hidden beaches.',
    trips: 6
  }, {
    id: 3,
    country: 'Spain',
    image: 'https://images.unsplash.com/photo-1512753360435-329c4535a9a7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    description: "Journey through Spain's varied terrain, from the Pyrenees mountains to the Camino de Santiago.",
    trips: 7
  }, {
    id: 4,
    country: 'Morocco',
    image: 'https://images.unsplash.com/photo-1489493887464-892be6d1daae?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1171&q=80',
    description: 'Trek through the Atlas Mountains and explore ancient villages with stunning desert views.',
    trips: 5
  }];
  return <section className="py-16 w-full" data-id="element-26">
      <div className="container mx-auto px-4" data-id="element-27">
        <div className="text-center mb-12" data-id="element-28">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-29">
            All Hiking Trips
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-30">
            Choose your perfect hiking destination from our carefully selected
            locations
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-31">
          {destinations.map(destination => <div key={destination.id} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition duration-300 flex flex-col" data-id="element-32">
              <div className="h-48 overflow-hidden" data-id="element-33">
                <img src={destination.image} alt={`Hiking in ${destination.country}`} className="w-full h-full object-cover transform hover:scale-105 transition duration-500" data-id="element-34" />
              </div>
              <div className="p-6 flex-grow" data-id="element-35">
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-36">
                  {destination.country}
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-37">{destination.description}</p>
              </div>
              <div className="px-6 pb-6" data-id="element-38">
                <Link to={`/${destination.country.toLowerCase()}`} className="block text-center bg-teal-600 hover:bg-teal-700 text-white font-medium py-2 px-4 rounded-md transition duration-300" data-id="element-39">
                  Read More
                </Link>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};